export default __webpack_public_path__ + "static/media/HowWorksBG.5d4ac867.png";